// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBodyBox_wrapper__11ypI"};